"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 26 19",
    width: props.size || props.width || "24px",
    id: "JCB",
    height: props.size || props.height || "24px"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#FFF"
  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    x1: "-57.527%",
    y1: "50.124%",
    x2: "232.391%",
    y2: "50.124%",
    id: "JCB__a"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#007940",
    offset: "0%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#00873F",
    offset: "22.85%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#40A737",
    offset: "74.33%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#5CB531",
    offset: "100%"
  })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    x1: ".183%",
    y1: "49.96%",
    x2: "100.273%",
    y2: "49.96%",
    id: "JCB__b"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#007940",
    offset: "0%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#00873F",
    offset: "22.85%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#40A737",
    offset: "74.33%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#5CB531",
    offset: "100%"
  })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    x1: "-62.802%",
    y1: "49.858%",
    x2: "253.671%",
    y2: "49.858%",
    id: "JCB__c"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#007940",
    offset: "0%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#00873F",
    offset: "22.85%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#40A737",
    offset: "74.33%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#5CB531",
    offset: "100%"
  })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    x1: ".176%",
    y1: "50.006%",
    x2: "101.808%",
    y2: "50.006%",
    id: "JCB__d"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#1F286F",
    offset: "0%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#004E94",
    offset: "47.51%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#0066B1",
    offset: "82.61%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#006FBC",
    offset: "100%"
  })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    x1: "-.576%",
    y1: "49.914%",
    x2: "98.133%",
    y2: "49.914%",
    id: "JCB__e"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#6C2C2F",
    offset: "0%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#882730",
    offset: "17.35%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#BE1833",
    offset: "57.31%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#DC0436",
    offset: "85.85%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#E60039",
    offset: "100%"
  }))), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.55 11.45h1.808c.051 0 .172-.017.223-.017a.807.807 0 00.637-.81.836.836 0 00-.637-.809c-.051-.017-.155-.017-.223-.017H1.55v1.653z",
    fill: "url(#JCB__a)",
    transform: "translate(17.359 .011)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.151.034A3.134 3.134 0 00.017 3.168v3.254h4.425c.104 0 .224 0 .31.018.999.051 1.74.568 1.74 1.463 0 .706-.5 1.309-1.43 1.43v.034c1.016.069 1.79.637 1.79 1.515 0 .947-.86 1.567-1.996 1.567H0v6.37h4.597a3.134 3.134 0 003.134-3.133V.034h-4.58z",
    fill: "url(#JCB__b)",
    transform: "translate(17.359 .011)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.995 8.11a.733.733 0 00-.637-.74c-.035 0-.121-.018-.173-.018H1.55v1.515h1.635c.052 0 .155 0 .173-.017a.733.733 0 00.637-.74z",
    fill: "url(#JCB__c)",
    transform: "translate(17.359 .011)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.188.046A3.134 3.134 0 00.054 3.179v7.731c.879.43 1.791.706 2.704.706 1.084 0 1.67-.654 1.67-1.55v-3.65h2.686v3.633c0 1.412-.878 2.566-3.857 2.566-1.808 0-3.22-.396-3.22-.396v6.595h4.597a3.134 3.134 0 003.134-3.134V.046h-4.58z",
    fill: "url(#JCB__d)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.849.046a3.134 3.134 0 00-3.134 3.133v4.098c.792-.671 2.17-1.102 4.39-.998 1.189.051 2.463.378 2.463.378v1.326c-.637-.327-1.395-.62-2.376-.688-1.687-.121-2.703.706-2.703 2.152 0 1.463 1.016 2.29 2.703 2.152.981-.069 1.739-.379 2.376-.689v1.326s-1.257.327-2.462.379c-2.221.103-3.599-.327-4.39-.999v7.232h4.597a3.134 3.134 0 003.133-3.134V.046H11.85z",
    fill: "url(#JCB__e)"
  })));
};
var _default = exports["default"] = SvgComponent;